export default (obj, path, defaultValue) => path.split('.')
  .reduce((a, c) =>
    a && (a[c] || a[c] === 0) ? a[c] : (defaultValue || null), obj
  )
